import { MeshPhysicalMaterial, MeshStandardMaterial } from "three";
import { ScharnierGLTFResult } from "../scharnier/ScharnierType";
import { SchuifGLTFResult } from "../schuif/SchuifType";
import { TaatsGLTFResult } from "../taats/TaatsType";
import { useLayoutAdjustments } from "./useLayoutAdjustments";

export const DeWaalLayoutXLXXL = ({
  chosenMaterial,
  nodes,
  doorIndex,
}: {
  chosenMaterial: MeshPhysicalMaterial | MeshStandardMaterial;
  nodes:
    | TaatsGLTFResult["nodes"]
    | SchuifGLTFResult["nodes"]
    | ScharnierGLTFResult["nodes"];

  doorIndex: number;
}) => {
  const { scaleDoorX, scaleDoorY, layoutOffsetX, selectedDoor } =
    useLayoutAdjustments({ doorIndex });
  const positionY =
    selectedDoor?.code === "dubbeleschuifdeur2paneel" ? -0.015 : 0;
  return (
    <group position-y={positionY}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.beam_dewaal_A_XL.geometry}
        material={chosenMaterial}
        position={[0.165 * scaleDoorX + layoutOffsetX, 0.63 * scaleDoorY, 0]}
        scale-y={scaleDoorY}
        scale-x={scaleDoorX}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.beam_dewaal_B.geometry}
        material={chosenMaterial}
        position={[-0.076 * scaleDoorX + layoutOffsetX, 2.025 * scaleDoorY, 0]}
        scale-y={scaleDoorY}
        scale-x={scaleDoorX}
      />
    </group>
  );
};
